import { getCookie } from '../utils/cookie-functions';

/** Making this a wrapper component for the whole footer if we need to add other exceptions/logic to links in the future.
 * We could have this component only wrap legal links for the OneTrust settings feature.
 * However, if it was desired to change the location of the link it would be possible by making `#one-trust-cookie-settings` the href of any link in the footer.
 */
class FooterWrapper extends HTMLElement {
  constructor() {
    super();
    this.oneTrustSettingsTrigger = this.querySelector('[data-onetrust-settings-trigger]');
  }

  connectedCallback() {
    if (this.oneTrustSettingsTrigger) {
      this.oneTrustSettingsTrigger.addEventListener('click', this.openOneTrustSettings.bind(this));
    }
    document.body.addEventListener('click', this.onConsentChange);
  }

  disconnectedCallback() {
    if (this.oneTrustSettingsTrigger) {
      this.oneTrustSettingsTrigger.removeEventListener('click', this.openOneTrustSettings);
    }
    document.body.removeEventListener('click', this.onConsentChange);
  }

  openOneTrustSettings() {
    if (!window.OneTrust) return;
    const gpcValue = navigator.globalPrivacyControl;
    if (gpcValue) {
      // eslint-disable-next-line no-alert
      alert(this.dataset.gpcMessage);
      window.OneTrust.ToggleInfoDisplay();
    } else {
      window.OneTrust.ToggleInfoDisplay();
    }
  }

  /* 
    This function is used to prevent OneTrust from overriding the DNS settings.
    Attempting to turn on marketing consent if the user has opted out of selling 
    data or limiting the use of data will prevent Marketing consent from turning on.
  */
  static preventOneTrustDNSOverride() {
    const doNotSell = getCookie('donotsell');
    const limitTheUse = getCookie('limittheuse');
    if (doNotSell || limitTheUse) {
      setTimeout(() => {
        window.OneTrust.UpdateConsent('Category', 'C0004:0');
      }, 500);
    }
  }

  onConsentChange(e) {
    const { target } = e;
    if (
      target.id === 'onetrust-reject-all-handler' ||
      target.id === 'onetrust-accept-btn-handler' ||
      target.classList.contains('save-preference-btn-handler') ||
      target.id === 'accept-recommended-btn-handler'
    ) {
      FooterWrapper.preventOneTrustDNSOverride();
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }
}

customElements.define('domaine-footer-wrapper', FooterWrapper);
